'use client';

/**
 * SysObeyaKpiCohesionFlaggedCard — Procedural Patterns KPI tile.
 *
 * Slices `response.totals.{total_flagged_classes, total_classes_analyzed}`
 * from the system_obeya_view cohesion call. Hero number is the flagged-
 * class count; sub-label gives the denominator ("of 482").
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_cohesion_flagged"
 * @see klyde_edge/ui_config/labels/system_obeya.py — cohesion_kpi_flagged_*
 */

import { ShieldAlert } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiCohesionFlaggedCard({ view_name = 'cohesion' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  // Denominator may be null on pre-projection graph states — omit the
  // sub-line rather than painting "of —".
  const denom = t.total_classes_analyzed;
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_cohesion_flagged"
      label={L.cohesion_kpi_flagged_label ?? ''}
      Icon={ShieldAlert}
      value={isLoading ? '…' : fmt(t.total_flagged_classes)}
      sub={denom != null ? `${L.cohesion_kpi_flagged_sub_prefix ?? ''}${fmt(denom)}` : undefined}
      queryKey={queryKey}
    />
  );
}
